import {GeneralTypeModel} from '../models/general-type.model';

export enum SourceTypeEnum {
  Book = 1,
  Article = 2,
  Video = 3,
  Podcast = 4,
  Website = 5,
  ResearchPaper = 6,
  Other = 255
}

export function sourceTypeEnumToGeneralTypeModel(type: SourceTypeEnum | null): GeneralTypeModel {
  switch (type) {
    case SourceTypeEnum.Book:
      return { name: 'Book', color: '#00a798'};
    case SourceTypeEnum.Article:
      return { name: 'Article', color: '#233e9b'};
    case SourceTypeEnum.Video:
      return { name: 'Video', color: '#005fd9'};
    case SourceTypeEnum.Podcast:
      return { name: 'Podcast', color: '#c75200'};
    case SourceTypeEnum.Website:
      return { name: 'Website', color: '#3200e5'};
    case SourceTypeEnum.ResearchPaper:
      return { name: 'ResearchPaper', color: '#9b2323'};
    case SourceTypeEnum.Other:
      return { name: 'Other', color: '#7b7b7b'};
    default:
      return { name: 'Unknown', color: '#7b7b7b'};
  }
}
